import { set_sub} from "../confg";
import {createAction} from "@reduxjs/toolkit";

export const subcategory_setter=createAction(set_sub);
